import { type ReactNode } from 'react';
import { ResponsiveLayout as QuizResponsiveLayout } from '../ResponsiveLayout/ResponsiveLayout';

interface Props {
  children: ReactNode;
  header: ReactNode;
  scrollRef?: React.RefObject<HTMLDivElement>;
}

export function Screen(props: Props) {
  const { children, header, scrollRef } = props;

  return (
    <QuizResponsiveLayout testid="quiz" header={header} scrollRef={scrollRef}>
      {children}
    </QuizResponsiveLayout>
  );
}
